import { Popper } from "@mui/material";
import { styled } from "@mui/material/styles";

const PREFIX = "FollowUpMenuPopper";

export const classes = {
  root: `${PREFIX}-root`,
};

export const FollowUpMenuPopper = styled(Popper)(({ theme }) => ({
  [`&.${classes.root}`]: {
    zIndex: 1300,
    border: `solid 1px ${theme.palette.border.main}`,
    backgroundColor: theme.palette.background.default,
  },
}));
